module.exports = __webpack_public_path__ + "assets/media/tongue_practice_light.44589e22.mp4";